<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-row>
        <a-col :span="12"> 基本信息 </a-col>
      </a-row>
      <a-form-model
        layout=""
        :model="data"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        labelAlign="left"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="订单编号">
              <a-input v-model="data.orderNo" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="下单时间">
              <a-input v-model="data.createTime" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="用户uid">
              <a-input v-model="data.userUid" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="用户手机号码">
              <a-input v-model="data.userPhone" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="支付彩票">
              <a-input v-model="data.payLottery" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="所属门店">
              <a-input v-model="data.shopName" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="订单数量">
              <a-input v-model="data.statusUserStr" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <!-- 第三方支付信息 -->
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-row>
        <a-col :span="12"> 商品信息 </a-col>
      </a-row>
      <a-table
        :columns="columns"
        :row-key="(record) => record.goodsId"
        :data-source="goods"
      >
        <template slot="pic2" slot-scope="text">
          <img class="img2" :src="text" alt="" />
        </template>
      </a-table>
    </div>
    <a-button size="large" @click="goBack" class="button">返回</a-button>
  </div>
</template>

<script>
import { storeExchangeOrderDetail, storeOrderDetails } from "@/api/storeApi.js";

const columns = [
  {
    title: "商品id",
    dataIndex: "goodsId",
    align: "center",

    // scopedSlots: { customRender: "name" },
  },
  {
    title: "商品名称",
    dataIndex: "goodsName",
    align: "center",

    // filters: [
    //   { text: "Male", value: "male" },
    //   { text: "Female", value: "female" },
    // ],
    // width: "10%",
  },
  {
    title: "商品图片",
    dataIndex: "goodsImg",
    // width: "15%",
    align: "center",
    scopedSlots: { customRender: "pic2" },
  },
  {
    title: "价格",
    dataIndex: "goodsSpecPrice",
    align: "center",
    // sorter: true,
    // width: "10%",
    // scopedSlots: { customRender: "avatar" },
  },

  {
    title: "商品数量",
    dataIndex: "priceDiscount",
    align: "center",
    // sorter: true,
    // width: "10%",
    // scopedSlots: { customRender: "name" },
  },
];
export default {
  components: {},
  data() {
    return {
      data: [],
      goods: [],
      orderNo: "",
      columns,
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      textarealabelCol: { span: 2 },
      textareaWrapperCol: { span: 21, offset: 1 },
      formInline: {
        user: "",
        password: "",
      },
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        // pageSizeOptions: ["10", "20", "40", "80", "100"],
        // showTotal: (total) => `共 ${total} 条`,
        // pageSize: 10,
      },
    };
  },
  mounted() {
    this.getOderDetailsList();
  },
  methods: {
    handleSubmit(e) {
      console.log(this.formInline);
    },
    onChange(date, dateString) {
      console.log(date, dateString);
    },
    goBack() {
      this.$router.push("/home/payForTheOrderTwo");
    },
    // 获取订单详情
    getOderDetailsList() {
      let orderNo = this.$route.query.orderNo;
      storeOrderDetails(orderNo).then((res) => {
        this.data = res.data;
        this.goods = res.data.goods;
        console.log(res);
      });
    },
  },
};
</script>

<style lang="scss" scoped="" type="text/css">
.button {
  margin-left: 15px;
}
.illustrate {
  color: red;
}
.img2 {
  width: 100px;
  height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/views/orderManagement/payForTheOrderTwo/payForTheOrderDetailsTwo.vue